!function (n, i) {
  "object" == typeof exports && "undefined" != typeof module ? i(exports, require("react"), require("prop-types"), require("styled-components")) : "function" == typeof define && define.amd ? define(["exports", "react", "prop-types", "styled-components"], i) : i((n = n || self).ReactEpicSpinners = {}, n.React, n.PropTypes, n.StyledComponents);
}(this, function (n, p, i, r) {
  "use strict";

  function d() {
    return (d = Object.assign || function (n) {
      for (var i = 1; i < arguments.length; i++) {
        var r = arguments[i];

        for (var e in r) {
          Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e]);
        }
      }

      return n;
    }).apply(this, arguments);
  }

  function h(n, i) {
    if (null == n) return {};
    var r,
        e,
        t = {},
        o = Object.keys(n);

    for (e = 0; e < o.length; e++) {
      r = o[e], 0 <= i.indexOf(r) || (t[r] = n[r]);
    }

    return t;
  }

  function e(n, i) {
    return i || (i = n.slice(0)), n.raw = i, n;
  }

  function t() {
    var n = e(["\n  height: ", "px;\n  width: ", "px;\n  overflow: hidden;\n\n  * {\n    box-sizing: border-box;\n  }\n\n  .spinner-inner {\n    position: relative;\n    display: block;\n    height: 100%;\n    width: 100%;\n  }\n\n  .spinner-circle {\n    display: block;\n    position: absolute;\n    color: ", ";\n    font-size: calc(", "px * 0.24);\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n  .spinner-line {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    animation-duration: ", "ms;\n    border-left-width: calc(", "px / 25);\n    border-top-width: calc(", "px / 25);\n    border-left-color: ", ";\n    border-left-style: solid;\n    border-top-style: solid;\n    border-top-color: transparent;\n  }\n\n  .spinner-line:nth-child(1) {\n    animation: atom-spinner-animation-1 ", "ms\n      linear infinite;\n    transform: rotateZ(120deg) rotateX(66deg) rotateZ(0deg);\n  }\n\n  .spinner-line:nth-child(2) {\n    animation: atom-spinner-animation-2 ", "ms\n      linear infinite;\n    transform: rotateZ(240deg) rotateX(66deg) rotateZ(0deg);\n  }\n\n  .spinner-line:nth-child(3) {\n    animation: atom-spinner-animation-3 ", "ms\n      linear infinite;\n    transform: rotateZ(360deg) rotateX(66deg) rotateZ(0deg);\n  }\n\n  @keyframes atom-spinner-animation-1 {\n    100% {\n      transform: rotateZ(120deg) rotateX(66deg) rotateZ(360deg);\n    }\n  }\n  @keyframes atom-spinner-animation-2 {\n    100% {\n      transform: rotateZ(240deg) rotateX(66deg) rotateZ(360deg);\n    }\n  }\n  @keyframes atom-spinner-animation-3 {\n    100% {\n      transform: rotateZ(360deg) rotateX(66deg) rotateZ(360deg);\n    }\n  }\n"]);
    return t = function t() {
      return n;
    }, n;
  }

  p = p && p.hasOwnProperty("default") ? p.default : p, i = i && i.hasOwnProperty("default") ? i.default : i;

  var m = (r = r && r.hasOwnProperty("default") ? r.default : r).div(t(), function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.animationDuration;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.animationDuration;
  }, function (n) {
    return n.animationDuration;
  }, function (n) {
    return n.animationDuration;
  }),
      o = {
    size: i.number,
    animationDuration: i.number,
    color: i.string,
    className: i.string,
    style: i.object
  },
      a = function a(n) {
    var i = n.size,
        r = void 0 === i ? 60 : i,
        e = n.animationDuration,
        t = void 0 === e ? 1e3 : e,
        o = n.color,
        a = void 0 === o ? "#fff" : o,
        c = n.className,
        s = void 0 === c ? "" : c,
        u = n.style,
        l = h(n, ["size", "animationDuration", "color", "className", "style"]);
    return p.createElement(m, d({
      size: r,
      color: a,
      animationDuration: t,
      className: "atom-spinner" + (s ? " " + s : ""),
      style: u
    }, l), p.createElement("div", {
      className: "spinner-inner"
    }, p.createElement("div", {
      className: "spinner-line"
    }), p.createElement("div", {
      className: "spinner-line"
    }), p.createElement("div", {
      className: "spinner-line"
    }), p.createElement("div", {
      className: "spinner-circle"
    }, "●")));
  };

  function c() {
    var n = e(["\n  height: ", "px;\n  width: ", "px;\n  position: relative;\n  transform: rotate(45deg);\n\n  * {\n    box-sizing: border-box;\n  }\n\n  .rhombus {\n    height: calc(", "px / 7.5);\n    width: calc(", "px / 7.5);\n    animation-duration: ", "ms;\n    top: calc(", "px / 2.3077);\n    left: calc(", "px / 2.3077);\n    background-color: ", ";\n    position: absolute;\n    animation-iteration-count: infinite;\n  }\n\n  .rhombus:nth-child(2n + 0) {\n    margin-right: 0;\n  }\n\n  .rhombus.child-1 {\n    animation-name: breeding-rhombus-spinner-animation-child-1;\n    animation-delay: calc(", "ms * 1);\n  }\n\n  .rhombus.child-2 {\n    animation-name: breeding-rhombus-spinner-animation-child-2;\n    animation-delay: calc(", "ms * 2);\n  }\n\n  .rhombus.child-3 {\n    animation-name: breeding-rhombus-spinner-animation-child-3;\n    animation-delay: calc(", "ms * 3);\n  }\n\n  .rhombus.child-4 {\n    animation-name: breeding-rhombus-spinner-animation-child-4;\n    animation-delay: calc(", "ms * 4);\n  }\n\n  .rhombus.child-5 {\n    animation-name: breeding-rhombus-spinner-animation-child-5;\n    animation-delay: calc(", "ms * 5);\n  }\n\n  .rhombus.child-6 {\n    animation-name: breeding-rhombus-spinner-animation-child-6;\n    animation-delay: calc(", "ms * 6);\n  }\n\n  .rhombus.child-7 {\n    animation-name: breeding-rhombus-spinner-animation-child-7;\n    animation-delay: calc(", "ms * 7);\n  }\n\n  .rhombus.child-8 {\n    animation-name: breeding-rhombus-spinner-animation-child-8;\n    animation-delay: calc(", "ms * 8);\n  }\n\n  .rhombus.big {\n    height: calc(", "px / 3);\n    width: calc(", "px / 3);\n    animation-duration: ", "ms;\n    top: calc(", "px / 3);\n    left: calc(", "px / 3);\n    background-color: ", ";\n    animation: breeding-rhombus-spinner-animation-child-big\n      ", " infinite;\n    animation-delay: 0.5s;\n  }\n\n  @keyframes breeding-rhombus-spinner-animation-child-1 {\n    50% {\n      transform: translate(-325%, -325%);\n    }\n  }\n  @keyframes breeding-rhombus-spinner-animation-child-2 {\n    50% {\n      transform: translate(0, -325%);\n    }\n  }\n  @keyframes breeding-rhombus-spinner-animation-child-3 {\n    50% {\n      transform: translate(325%, -325%);\n    }\n  }\n  @keyframes breeding-rhombus-spinner-animation-child-4 {\n    50% {\n      transform: translate(325%, 0);\n    }\n  }\n  @keyframes breeding-rhombus-spinner-animation-child-5 {\n    50% {\n      transform: translate(325%, 325%);\n    }\n  }\n  @keyframes breeding-rhombus-spinner-animation-child-6 {\n    50% {\n      transform: translate(0, 325%);\n    }\n  }\n  @keyframes breeding-rhombus-spinner-animation-child-7 {\n    50% {\n      transform: translate(-325%, 325%);\n    }\n  }\n  @keyframes breeding-rhombus-spinner-animation-child-8 {\n    50% {\n      transform: translate(-325%, 0);\n    }\n  }\n  @keyframes breeding-rhombus-spinner-animation-child-big {\n    50% {\n      transform: scale(0.5);\n    }\n  }\n"]);
    return c = function c() {
      return n;
    }, n;
  }

  a.propTypes = o;
  var f = r.div(c(), function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.animationDuration;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.delayModifier;
  }, function (n) {
    return n.delayModifier;
  }, function (n) {
    return n.delayModifier;
  }, function (n) {
    return n.delayModifier;
  }, function (n) {
    return n.delayModifier;
  }, function (n) {
    return n.delayModifier;
  }, function (n) {
    return n.delayModifier;
  }, function (n) {
    return n.delayModifier;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.animationDuration;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.animationDuration;
  }),
      s = {
    size: i.number,
    animationDuration: i.number,
    color: i.string,
    className: i.string,
    style: i.object
  };

  var u = function u(n) {
    var i,
        r = n.size,
        e = void 0 === r ? 150 : r,
        t = n.color,
        o = void 0 === t ? "#fff" : t,
        a = n.animationDuration,
        c = void 0 === a ? 2e3 : a,
        s = n.className,
        u = void 0 === s ? "" : s,
        l = n.style,
        m = h(n, ["size", "color", "animationDuration", "className", "style"]);
    return p.createElement(f, d({
      size: e,
      color: o,
      animationDuration: c,
      className: "breeding-rhombus-spinner" + (u ? " " + u : ""),
      style: l,
      delayModifier: .05 * c
    }, m), (i = 8, Array.from({
      length: i
    }).map(function (n, i) {
      return p.createElement("div", {
        key: i,
        className: "rhombus child-" + (i + 1)
      });
    })), p.createElement("div", {
      className: "rhombus big"
    }));
  };

  function l() {
    var n = e(["\n  height: ", "px;\n  width: ", "px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  * {\n    box-sizing: border-box;\n  }\n\n  .circle {\n    height: ", "px;\n    width: ", "px;\n    margin-left: ", "px;\n    transform: rotate(45deg);\n    border-radius: 10%;\n    border: 3px solid ", ";\n    overflow: hidden;\n    background: transparent;\n    animation: circles-to-rhombuses-animation\n      ", "ms linear infinite;\n  }\n  .circle:nth-child(1) {\n    animation-delay: calc(", "ms * 1);\n    margin-left: 0;\n  }\n  .circle:nth-child(2) {\n    animation-delay: calc(", "ms * 2);\n  }\n  .circle:nth-child(3) {\n    animation-delay: calc(", "ms * 3);\n  }\n  @keyframes circles-to-rhombuses-animation {\n    0% {\n      border-radius: 10%;\n    }\n    17.5% {\n      border-radius: 10%;\n    }\n    50% {\n      border-radius: 100%;\n    }\n    93.5% {\n      border-radius: 10%;\n    }\n    100% {\n      border-radius: 10%;\n    }\n  }\n"]);
    return l = function l() {
      return n;
    }, n;
  }

  u.propTypes = s;
  var x = r.div(l(), function (n) {
    return n.size;
  }, function (n) {
    return (n.size + n.circleMarginLeft) * n.circleNum;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.circleMarginLeft;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.animationDuration;
  }, function (n) {
    return n.delay;
  }, function (n) {
    return n.delay;
  }, function (n) {
    return n.delay;
  }),
      g = {
    size: i.number,
    animationDuration: i.number,
    color: i.string,
    className: i.string,
    style: i.object
  };

  var b = function b(n) {
    var i,
        r = n.size,
        e = void 0 === r ? 15 : r,
        t = n.color,
        o = void 0 === t ? "#fff" : t,
        a = n.animationDuration,
        c = void 0 === a ? 1200 : a,
        s = n.className,
        u = void 0 === s ? "" : s,
        l = n.style,
        m = h(n, ["size", "color", "animationDuration", "className", "style"]),
        f = 1.125 * e;
    return p.createElement(x, d({
      size: e,
      color: o,
      animationDuration: c,
      className: "circles-to-rhombuses-spinner" + (u ? " " + u : ""),
      style: l,
      circleMarginLeft: f,
      delay: 150,
      circleNum: 3
    }, m), (i = 3, Array.from({
      length: i
    }).map(function (n, i) {
      return p.createElement("div", {
        key: i,
        className: "circle"
      });
    })));
  };

  function z() {
    var n = e(["\n  height: ", "px;\n  width: ", "px;\n  padding: ", "px;\n  overflow: hidden;\n  position: relative;\n\n  * {\n    box-sizing: border-box;\n  }\n\n  .spinner-ring {\n    position: absolute;\n    border-radius: 50%;\n    border: 2px solid transparent;\n    border-top-color: ", ";\n    animation: fingerprint-spinner-animation\n      ", "ms\n      cubic-bezier(0.68, -0.75, 0.265, 1.75) infinite forwards;\n    margin: auto;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    top: 0;\n  }\n  .spinner-ring:nth-child(1) {\n    height: ", "px;\n    width: ", "px;\n    animation-delay: calc(50ms * 1);\n  }\n  .spinner-ring:nth-child(2) {\n    height: ", "px;\n    width: ", "px;\n    animation-delay: calc(50ms * 2);\n  }\n  .spinner-ring:nth-child(3) {\n    height: ", "px;\n    width: ", "px;\n    animation-delay: calc(50ms * 3);\n  }\n  .spinner-ring:nth-child(4) {\n    height: ", "px;\n    width: ", "px;\n    animation-delay: calc(50ms * 4);\n  }\n  .spinner-ring:nth-child(5) {\n    height: ", "px;\n    width: ", "px;\n    animation-delay: calc(50ms * 5);\n  }\n  .spinner-ring:nth-child(6) {\n    height: ", "px;\n    width: ", "px;\n    animation-delay: calc(50ms * 6);\n  }\n  .spinner-ring:nth-child(7) {\n    height: ", "px;\n    width: ", "px;\n    animation-delay: calc(50ms * 7);\n  }\n  .spinner-ring:nth-child(8) {\n    height: ", "px;\n    width: ", "px;\n    animation-delay: calc(50ms * 8);\n  }\n  .spinner-ring:nth-child(9) {\n    height: ", "px;\n    width: ", "px;\n    animation-delay: calc(50ms * 9);\n  }\n\n  @keyframes fingerprint-spinner-animation {\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"]);
    return z = function z() {
      return n;
    }, n;
  }

  b.propTypes = g;
  var y = r.div(z(), function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.containerPadding;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.animationDuration;
  }, function (n) {
    return n.ringBase + 0 * n.ringBase;
  }, function (n) {
    return n.ringBase + 0 * n.ringBase;
  }, function (n) {
    return n.ringBase + 1 * n.ringBase;
  }, function (n) {
    return n.ringBase + 1 * n.ringBase;
  }, function (n) {
    return n.ringBase + 2 * n.ringBase;
  }, function (n) {
    return n.ringBase + 2 * n.ringBase;
  }, function (n) {
    return n.ringBase + 3 * n.ringBase;
  }, function (n) {
    return n.ringBase + 3 * n.ringBase;
  }, function (n) {
    return n.ringBase + 4 * n.ringBase;
  }, function (n) {
    return n.ringBase + 4 * n.ringBase;
  }, function (n) {
    return n.ringBase + 5 * n.ringBase;
  }, function (n) {
    return n.ringBase + 5 * n.ringBase;
  }, function (n) {
    return n.ringBase + 6 * n.ringBase;
  }, function (n) {
    return n.ringBase + 6 * n.ringBase;
  }, function (n) {
    return n.ringBase + 7 * n.ringBase;
  }, function (n) {
    return n.ringBase + 7 * n.ringBase;
  }, function (n) {
    return n.ringBase + 8 * n.ringBase;
  }, function (n) {
    return n.ringBase + 8 * n.ringBase;
  }),
      v = {
    size: i.number,
    animationDuration: i.number,
    color: i.string,
    className: i.string,
    style: i.object
  };

  var D = function D(n) {
    var i,
        r = n.size,
        e = void 0 === r ? 60 : r,
        t = n.color,
        o = void 0 === t ? "#fff" : t,
        a = n.animationDuration,
        c = void 0 === a ? 1500 : a,
        s = n.className,
        u = void 0 === s ? "" : s,
        l = n.style,
        m = h(n, ["size", "color", "animationDuration", "className", "style"]),
        f = (e - 4) / 9;
    return p.createElement(y, d({
      size: e,
      color: o,
      animationDuration: c,
      className: "fingerprint-spinner" + (u ? " " + u : ""),
      style: l,
      ringBase: f,
      containerPadding: 2
    }, m), (i = 9, Array.from({
      length: i
    }).map(function (n, i) {
      return p.createElement("div", {
        key: i,
        className: "spinner-ring"
      });
    })));
  };

  function N() {
    var n = e(["\n  height: ", "px;\n  width: ", "px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n\n  * {\n    box-sizing: border-box;\n  }\n\n  .dots-container {\n    height: ", "px;\n    width: ", "px;\n  }\n  .smaller-dot {\n    background: ", ";\n    height: 100%;\n    width: 100%;\n    border-radius: 50%;\n    animation: flower-spinner-smaller-dot-animation\n      ", "ms 0s infinite both;\n  }\n  .bigger-dot {\n    background: ", ";\n    height: 100%;\n    width: 100%;\n    padding: 10%;\n    border-radius: 50%;\n    animation: flower-spinner-bigger-dot-animation\n      ", "ms 0s infinite both;\n  }\n  @keyframes flower-spinner-bigger-dot-animation {\n    0%,\n    100% {\n      box-shadow: 0px 0px 0px ", ",\n        0px 0px 0px ", ",\n        0px 0px 0px ", ",\n        0px 0px 0px ", ",\n        0px 0px 0px ", ",\n        0px 0px 0px ", ",\n        0px 0px 0px ", ",\n        0px 0px 0px ", ";\n    }\n    50% {\n      transform: rotate(180deg);\n    }\n    25%,\n    75% {\n      box-shadow: ", "px 0 0\n          ", ",\n        -", "px 0 0 ", ",\n        0 ", "px 0 ", ",\n        0 -", "px 0 ", ",\n        ", "px -", "px\n          0 ", ",\n        ", "px ", "px\n          0 ", ",\n        -", "px -", "px\n          0 ", ",\n        -", "px ", "px\n          0 ", ";\n    }\n    100% {\n      transform: rotate(360deg);\n      box-shadow: 0px 0px 0px ", ",\n        0px 0px 0px ", ",\n        0px 0px 0px ", ",\n        0px 0px 0px ", ",\n        0px 0px 0px ", ",\n        0px 0px 0px ", ",\n        0px 0px 0px ", ",\n        0px 0px 0px ", ";\n    }\n  }\n  @keyframes flower-spinner-smaller-dot-animation {\n    0%,\n    100% {\n      box-shadow: 0px 0px 0px ", ",\n        0px 0px 0px ", ",\n        0px 0px 0px ", ",\n        0px 0px 0px ", ",\n        0px 0px 0px ", ",\n        0px 0px 0px ", ",\n        0px 0px 0px ", ",\n        0px 0px 0px ", ";\n    }\n    25%,\n    75% {\n      box-shadow: ", "px 0 0\n          ", ",\n        -", "px 0 0 ", ",\n        0 ", "px 0 ", ",\n        0 -", "px 0 ", ",\n        ", "px -", "px 0 ", ",\n        ", "px ", "px 0\n          ", ",\n        -", "px -", "px 0\n          ", ",\n        -", "px ", "px 0 ", ";\n    }\n    100% {\n      box-shadow: 0px 0px 0px ", ",\n        0px 0px 0px ", ",\n        0px 0px 0px ", ",\n        0px 0px 0px ", ",\n        0px 0px 0px ", ",\n        0px 0px 0px ", ",\n        0px 0px 0px ", ",\n        0px 0px 0px ", ";\n    }\n  }\n"]);
    return N = function N() {
      return n;
    }, n;
  }

  D.propTypes = v;

  var w = r.div(N(), function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.dotSize;
  }, function (n) {
    return n.dotSize;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.animationDuration;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.animationDuration;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.color;
  }, function (n) {
    return 2.6 * n.dotSize;
  }, function (n) {
    return n.color;
  }, function (n) {
    return 2.6 * n.dotSize;
  }, function (n) {
    return n.color;
  }, function (n) {
    return 2.6 * n.dotSize;
  }, function (n) {
    return n.color;
  }, function (n) {
    return 2.6 * n.dotSize;
  }, function (n) {
    return n.color;
  }, function (n) {
    return 1.9 * n.dotSize;
  }, function (n) {
    return 1.9 * n.dotSize;
  }, function (n) {
    return n.color;
  }, function (n) {
    return 1.9 * n.dotSize;
  }, function (n) {
    return 1.9 * n.dotSize;
  }, function (n) {
    return n.color;
  }, function (n) {
    return 1.9 * n.dotSize;
  }, function (n) {
    return 1.9 * n.dotSize;
  }, function (n) {
    return n.color;
  }, function (n) {
    return 1.9 * n.dotSize;
  }, function (n) {
    return 1.9 * n.dotSize;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.color;
  }, function (n) {
    return 1.4 * n.dotSize;
  }, function (n) {
    return n.color;
  }, function (n) {
    return 1.4 * n.dotSize;
  }, function (n) {
    return n.color;
  }, function (n) {
    return 1.4 * n.dotSize;
  }, function (n) {
    return n.color;
  }, function (n) {
    return 1.4 * n.dotSize;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.dotSize;
  }, function (n) {
    return n.dotSize;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.dotSize;
  }, function (n) {
    return n.dotSize;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.dotSize;
  }, function (n) {
    return n.dotSize;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.dotSize;
  }, function (n) {
    return n.dotSize;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.color;
  }),
      S = {
    size: i.number,
    animationDuration: i.number,
    color: i.string,
    className: i.string,
    style: i.object
  },
      k = function k(n) {
    var i = n.size,
        r = void 0 === i ? 70 : i,
        e = n.color,
        t = void 0 === e ? "#fff" : e,
        o = n.animationDuration,
        a = void 0 === o ? 2500 : o,
        c = n.className,
        s = void 0 === c ? "" : c,
        u = n.style,
        l = h(n, ["size", "color", "animationDuration", "className", "style"]),
        m = r / 7;
    return p.createElement(w, d({
      size: r,
      color: t,
      animationDuration: a,
      className: "flower-spinner" + (s ? " " + s : ""),
      style: u,
      dotSize: m
    }, l), p.createElement("div", {
      className: "dots-container"
    }, p.createElement("div", {
      className: "bigger-dot"
    }, p.createElement("div", {
      className: "smaller-dot"
    }))));
  };

  function E() {
    var n = e(["\n  height: ", "px;\n  width: ", "px;\n  position: relative;\n  animation: fulfilling-bouncing-circle-spinner-animation infinite\n    ", "ms ease;\n\n  * {\n    box-sizing: border-box;\n  }\n\n  .orbit {\n    height: ", "px;\n    width: ", "px;\n    position: absolute;\n    top: 0;\n    left: 0;\n    border-radius: 50%;\n    border: calc(", "px * 0.03) solid\n      ", ";\n    animation: fulfilling-bouncing-circle-spinner-orbit-animation infinite\n      ", "ms ease;\n  }\n  .circle {\n    height: ", "px;\n    width: ", "px;\n    color: ", ";\n    display: block;\n    border-radius: 50%;\n    position: relative;\n    border: calc(", "px * 0.1) solid\n      ", ";\n    animation: fulfilling-bouncing-circle-spinner-circle-animation infinite\n      ", "ms ease;\n    transform: rotate(0deg) scale(1);\n  }\n  @keyframes fulfilling-bouncing-circle-spinner-animation {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n  @keyframes fulfilling-bouncing-circle-spinner-orbit-animation {\n    0% {\n      transform: scale(1);\n    }\n    50% {\n      transform: scale(1);\n    }\n    62.5% {\n      transform: scale(0.8);\n    }\n    75% {\n      transform: scale(1);\n    }\n    87.5% {\n      transform: scale(0.8);\n    }\n    100% {\n      transform: scale(1);\n    }\n  }\n  @keyframes fulfilling-bouncing-circle-spinner-circle-animation {\n    0% {\n      transform: scale(1);\n      border-color: transparent;\n      border-top-color: inherit;\n    }\n    16.7% {\n      border-color: transparent;\n      border-top-color: initial;\n      border-right-color: initial;\n    }\n    33.4% {\n      border-color: transparent;\n      border-top-color: inherit;\n      border-right-color: inherit;\n      border-bottom-color: inherit;\n    }\n    50% {\n      border-color: inherit;\n      transform: scale(1);\n    }\n    62.5% {\n      border-color: inherit;\n      transform: scale(1.4);\n    }\n    75% {\n      border-color: inherit;\n      transform: scale(1);\n      opacity: 1;\n    }\n    87.5% {\n      border-color: inherit;\n      transform: scale(1.4);\n    }\n    100% {\n      border-color: transparent;\n      border-top-color: inherit;\n      transform: scale(1);\n    }\n  }\n"]);
    return E = function E() {
      return n;
    }, n;
  }

  k.propTypes = S;

  var q = r.div(E(), function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.animationDuration;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.animationDuration;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.animationDuration;
  }),
      B = {
    size: i.number,
    animationDuration: i.number,
    color: i.string,
    className: i.string,
    style: i.object
  },
      j = function j(n) {
    var i = n.size,
        r = void 0 === i ? 60 : i,
        e = n.color,
        t = void 0 === e ? "#fff" : e,
        o = n.animationDuration,
        a = void 0 === o ? 4e3 : o,
        c = n.className,
        s = void 0 === c ? "" : c,
        u = n.style,
        l = h(n, ["size", "color", "animationDuration", "className", "style"]);
    return p.createElement(q, d({
      size: r,
      color: t,
      animationDuration: a,
      className: "fulfilling-bouncing-circle-spinner" + (s ? " " + s : ""),
      style: u
    }, l), p.createElement("div", {
      className: "circle"
    }), p.createElement("div", {
      className: "orbit"
    }));
  };

  function T() {
    var n = e(["\n  height: ", "px;\n  width: ", "px;\n  position: relative;\n  border: 4px solid ", ";\n  animation: fulfilling-square-spinner-animation\n    ", "ms infinite ease;\n\n  * {\n    box-sizing: border-box;\n  }\n\n  .spinner-inner {\n    vertical-align: top;\n    display: inline-block;\n    background-color: ", ";\n    width: 100%;\n    opacity: 1;\n    animation: fulfilling-square-spinner-inner-animation\n      ", "ms infinite ease-in;\n  }\n\n  @keyframes fulfilling-square-spinner-animation {\n    0% {\n      transform: rotate(0deg);\n    }\n    25% {\n      transform: rotate(180deg);\n    }\n    50% {\n      transform: rotate(180deg);\n    }\n    75% {\n      transform: rotate(360deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  @keyframes fulfilling-square-spinner-inner-animation {\n    0% {\n      height: 0%;\n    }\n    25% {\n      height: 0%;\n    }\n    50% {\n      height: 100%;\n    }\n    75% {\n      height: 100%;\n    }\n    100% {\n      height: 0%;\n    }\n  }\n"]);
    return T = function T() {
      return n;
    }, n;
  }

  j.propTypes = B;

  var Z = r.div(T(), function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.animationDuration;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.animationDuration;
  }),
      X = {
    size: i.number,
    animationDuration: i.number,
    color: i.string,
    className: i.string,
    style: i.object
  },
      M = function M(n) {
    var i = n.size,
        r = void 0 === i ? 50 : i,
        e = n.color,
        t = void 0 === e ? "#fff" : e,
        o = n.animationDuration,
        a = void 0 === o ? 4e3 : o,
        c = n.className,
        s = void 0 === c ? "" : c,
        u = n.style,
        l = h(n, ["size", "color", "animationDuration", "className", "style"]);
    return p.createElement(Z, d({
      size: r,
      color: t,
      animationDuration: a,
      className: "fulfilling-square-spinner" + (s ? " " + s : ""),
      style: u
    }, l), p.createElement("div", {
      className: "spinner-inner"
    }));
  };

  function W() {
    var n = e(["\n  width: ", "px;\n  height: ", "px;\n  border-radius: 100%;\n  position: relative;\n\n  * {\n    box-sizing: border-box;\n  }\n\n  .circle {\n    content: '';\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    border-radius: 100%;\n    border: calc(", "px / 10) solid transparent;\n  }\n  .circle.circle-1 {\n    border-top-color: ", ";\n    animation: half-circle-spinner-animation\n      ", "ms infinite;\n  }\n  .circle.circle-2 {\n    border-bottom-color: ", ";\n    animation: half-circle-spinner-animation\n      ", "ms infinite alternate;\n  }\n  @keyframes half-circle-spinner-animation {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"]);
    return W = function W() {
      return n;
    }, n;
  }

  M.propTypes = X;

  var A = r.div(W(), function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.animationDuration;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.animationDuration;
  }),
      P = {
    size: i.number,
    animationDuration: i.number,
    color: i.string,
    className: i.string,
    style: i.object
  },
      O = function O(n) {
    var i = n.size,
        r = void 0 === i ? 60 : i,
        e = n.color,
        t = void 0 === e ? "#fff" : e,
        o = n.animationDuration,
        a = void 0 === o ? 1e3 : o,
        c = n.className,
        s = void 0 === c ? "" : c,
        u = n.style,
        l = h(n, ["size", "color", "animationDuration", "className", "style"]);
    return p.createElement(A, d({
      size: r,
      color: t,
      animationDuration: a,
      className: "half-circle-spinner" + (s ? " " + s : ""),
      style: u
    }, l), p.createElement("div", {
      className: "circle circle-1"
    }), p.createElement("div", {
      className: "circle circle-2"
    }));
  };

  function Y() {
    var n = e(["\n  height: ", "px;\n  width: ", "px;\n\n  * {\n    box-sizing: border-box;\n  }\n\n  .dot {\n    width: ", "px;\n    height: ", "px;\n    margin: 0 calc(", "px / 2);\n    border: calc(", "px / 5) solid ", ";\n    border-radius: 50%;\n    float: left;\n    transform: scale(0);\n    animation: hollow-dots-spinner-animation\n      ", "ms ease infinite 0ms;\n  }\n  .dot:nth-child(1) {\n    animation-delay: calc(", "ms * 1);\n  }\n  .dot:nth-child(2) {\n    animation-delay: calc(", "ms * 2);\n  }\n  .dot:nth-child(3) {\n    animation-delay: calc(", "ms * 3);\n  }\n  @keyframes hollow-dots-spinner-animation {\n    50% {\n      transform: scale(1);\n      opacity: 1;\n    }\n    100% {\n      opacity: 0;\n    }\n  }\n"]);
    return Y = function Y() {
      return n;
    }, n;
  }

  O.propTypes = P;
  var R = r.div(Y(), function (n) {
    return n.size;
  }, function (n) {
    return 2 * n.size * n.dotsNum;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.animationDuration;
  }, function (n) {
    return n.animationDelay;
  }, function (n) {
    return n.animationDelay;
  }, function (n) {
    return n.animationDelay;
  }),
      C = {
    size: i.number,
    animationDuration: i.number,
    color: i.string,
    className: i.string,
    style: i.object
  };

  var F = function F(n) {
    var i,
        r = n.size,
        e = void 0 === r ? 15 : r,
        t = n.color,
        o = void 0 === t ? "#fff" : t,
        a = n.animationDuration,
        c = void 0 === a ? 1e3 : a,
        s = n.className,
        u = void 0 === s ? "" : s,
        l = n.style,
        m = h(n, ["size", "color", "animationDuration", "className", "style"]),
        f = .3 * c;
    return p.createElement(R, d({
      size: e,
      color: o,
      animationDuration: c,
      className: "hollow-dots-spinner" + (u ? " " + u : ""),
      style: l,
      dotsNum: 3,
      animationDelay: f
    }, m), (i = 3, Array.from({
      length: i
    }).map(function (n, i) {
      return p.createElement("div", {
        key: i,
        className: "dot"
      });
    })));
  };

  function L() {
    var n = e(["\n  height: ", "px;\n  width: ", "px;\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n\n  * {\n    box-sizing: border-box;\n  }\n\n  .spinnerBlock {\n    animation: intersecting-circles-spinners-animation\n      ", "ms linear infinite;\n    transform-origin: center;\n    display: block;\n    height: ", "px;\n    width: ", "px;\n  }\n  .circle {\n    display: block;\n    border: 2px solid ", ";\n    border-radius: 50%;\n    height: 100%;\n    width: 100%;\n    position: absolute;\n    left: 0;\n    top: 0;\n  }\n  .circle:nth-child(1) {\n    left: 0;\n    top: 0;\n  }\n  .circle:nth-child(2) {\n    left: ", "px;\n    top: ", "px;\n  }\n  .circle:nth-child(3) {\n    left: ", "px;\n    top: ", "px;\n  }\n  .circle:nth-child(4) {\n    left: 0;\n    top: ", "px;\n  }\n  .circle:nth-child(5) {\n    left: ", "px;\n    top: ", "px;\n  }\n  .circle:nth-child(6) {\n    left: ", "px;\n    top: ", "px;\n  }\n  .circle:nth-child(7) {\n    left: 0;\n    top: ", "px;\n  }\n  @keyframes intersecting-circles-spinners-animation {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }\n"]);
    return L = function L() {
      return n;
    }, n;
  }

  F.propTypes = C;
  var H = r.div(L(), function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.animationDuration;
  }, function (n) {
    return n.circleSize;
  }, function (n) {
    return n.circleSize;
  }, function (n) {
    return n.color;
  }, function (n) {
    return -.36 * n.circleSize;
  }, function (n) {
    return .2 * n.circleSize;
  }, function (n) {
    return -.36 * n.circleSize;
  }, function (n) {
    return -.2 * n.circleSize;
  }, function (n) {
    return -.36 * n.circleSize;
  }, function (n) {
    return .36 * n.circleSize;
  }, function (n) {
    return -.2 * n.circleSize;
  }, function (n) {
    return .36 * n.circleSize;
  }, function (n) {
    return .2 * n.circleSize;
  }, function (n) {
    return .36 * n.circleSize;
  }),
      _ = {
    size: i.number,
    animationDuration: i.number,
    color: i.string,
    className: i.string,
    style: i.object
  };

  var I = function I(n) {
    var i,
        r = n.size,
        e = void 0 === r ? 70 : r,
        t = n.color,
        o = void 0 === t ? "#fff" : t,
        a = n.animationDuration,
        c = void 0 === a ? 1200 : a,
        s = n.className,
        u = void 0 === s ? "" : s,
        l = n.style,
        m = h(n, ["size", "color", "animationDuration", "className", "style"]),
        f = e / 2;
    return p.createElement(H, d({
      size: e,
      color: o,
      animationDuration: c,
      className: "intersecting-circles-spinner" + (u ? " " + u : ""),
      style: l,
      circleSize: f
    }, m), p.createElement("div", {
      className: "spinnerBlock"
    }, (i = 7, Array.from({
      length: i
    }).map(function (n, i) {
      return p.createElement("span", {
        key: i,
        className: "circle"
      });
    }))));
  };

  function G() {
    var n = e(["\n  width: ", "px;\n  height: ", "px;\n  position: relative;\n\n  * {\n    box-sizing: border-box;\n  }\n\n  .rhombus {\n    height: ", "px;\n    width: ", "px;\n    background-color: ", ";\n    left: ", "px;\n    position: absolute;\n    margin: 0 auto;\n    border-radius: 2px;\n    transform: translateY(0) rotate(45deg) scale(0);\n    animation: looping-rhombuses-spinner-animation\n      ", "ms linear infinite;\n  }\n  .rhombus:nth-child(1) {\n    animation-delay: calc(", "ms * 1 / -1.5);\n  }\n  .rhombus:nth-child(2) {\n    animation-delay: calc(", "ms * 2 / -1.5);\n  }\n  .rhombus:nth-child(3) {\n    animation-delay: calc(", "ms * 3 / -1.5);\n  }\n  @keyframes looping-rhombuses-spinner-animation {\n    0% {\n      transform: translateX(0) rotate(45deg) scale(0);\n    }\n    50% {\n      transform: translateX(-233%) rotate(45deg) scale(1);\n    }\n    100% {\n      transform: translateX(-466%) rotate(45deg) scale(0);\n    }\n  }\n"]);
    return G = function G() {
      return n;
    }, n;
  }

  I.propTypes = _;
  var J = r.div(G(), function (n) {
    return 4 * n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.color;
  }, function (n) {
    return 4 * n.size;
  }, function (n) {
    return n.animationDuration;
  }, function (n) {
    return n.animationDuration;
  }, function (n) {
    return n.animationDuration;
  }, function (n) {
    return n.animationDuration;
  }),
      K = {
    size: i.number,
    animationDuration: i.number,
    color: i.string,
    className: i.string,
    style: i.object
  };

  var Q = function Q(n) {
    var i,
        r = n.size,
        e = void 0 === r ? 15 : r,
        t = n.color,
        o = void 0 === t ? "#fff" : t,
        a = n.animationDuration,
        c = void 0 === a ? 2500 : a,
        s = n.className,
        u = void 0 === s ? "" : s,
        l = n.style,
        m = h(n, ["size", "color", "animationDuration", "className", "style"]);
    return p.createElement(J, d({
      size: e,
      color: o,
      animationDuration: c,
      className: "looping-rhombuses-spinner" + (u ? " " + u : ""),
      style: l
    }, m), (i = 3, Array.from({
      length: i
    }).map(function (n, i) {
      return p.createElement("div", {
        key: i,
        className: "rhombus"
      });
    })));
  };

  function U() {
    var n = e(["\n  height: ", "px;\n  width: ", "px;\n  border-radius: 50%;\n  perspective: 800px;\n\n  * {\n    box-sizing: border-box;\n  }\n\n  .orbit {\n    position: absolute;\n    box-sizing: border-box;\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n  }\n  .orbit:nth-child(1) {\n    left: 0%;\n    top: 0%;\n    animation: orbit-spinner-orbit-one-animation\n      ", "ms linear infinite;\n    border-bottom: 3px solid ", ";\n  }\n  .orbit:nth-child(2) {\n    right: 0%;\n    top: 0%;\n    animation: orbit-spinner-orbit-two-animation\n      ", "ms linear infinite;\n    border-right: 3px solid ", ";\n  }\n  .orbit:nth-child(3) {\n    right: 0%;\n    bottom: 0%;\n    animation: orbit-spinner-orbit-three-animation\n      ", "ms linear infinite;\n    border-top: 3px solid ", ";\n  }\n  @keyframes orbit-spinner-orbit-one-animation {\n    0% {\n      transform: rotateX(35deg) rotateY(-45deg) rotateZ(0deg);\n    }\n    100% {\n      transform: rotateX(35deg) rotateY(-45deg) rotateZ(360deg);\n    }\n  }\n  @keyframes orbit-spinner-orbit-two-animation {\n    0% {\n      transform: rotateX(50deg) rotateY(10deg) rotateZ(0deg);\n    }\n    100% {\n      transform: rotateX(50deg) rotateY(10deg) rotateZ(360deg);\n    }\n  }\n  @keyframes orbit-spinner-orbit-three-animation {\n    0% {\n      transform: rotateX(35deg) rotateY(55deg) rotateZ(0deg);\n    }\n    100% {\n      transform: rotateX(35deg) rotateY(55deg) rotateZ(360deg);\n    }\n  }\n"]);
    return U = function U() {
      return n;
    }, n;
  }

  Q.propTypes = K;

  var V = r.div(U(), function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.animationDuration;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.animationDuration;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.animationDuration;
  }, function (n) {
    return n.color;
  }),
      $ = {
    size: i.number,
    animationDuration: i.number,
    color: i.string,
    className: i.string,
    style: i.object
  },
      nn = function nn(n) {
    var i = n.size,
        r = void 0 === i ? 50 : i,
        e = n.color,
        t = void 0 === e ? "#fff" : e,
        o = n.animationDuration,
        a = void 0 === o ? 1e3 : o,
        c = n.className,
        s = void 0 === c ? "" : c,
        u = n.style,
        l = h(n, ["size", "color", "animationDuration", "className", "style"]);
    return p.createElement(V, d({
      size: r,
      color: t,
      animationDuration: a,
      className: "orbit-spinner" + (s ? " " + s : ""),
      style: u
    }, l), p.createElement("div", {
      className: "orbit one"
    }), p.createElement("div", {
      className: "orbit two"
    }), p.createElement("div", {
      className: "orbit three"
    }));
  };

  function rn() {
    var n = e(["\n  height: ", "px;\n  width: ", "px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n\n  * {\n    box-sizing: border-box;\n  }\n\n  .pixel-spinner-inner {\n    width: ", "px;\n    height: ", "px;\n    background-color: ", ";\n    color: ", ";\n\n    box-shadow: ", "px\n        ", "px 0 0,\n      ", "px\n        ", "px 0 0,\n      ", "px\n        ", "px 0 0,\n      ", "px\n        ", "px 0 0,\n      0 ", "px 0 0,\n      ", "px 0 0 0,\n      ", "px 0 0 0,\n      0 ", "px 0 0;\n    animation: pixel-spinner-animation ", "ms\n      linear infinite;\n  }\n\n  @keyframes pixel-spinner-animation {\n    50% {\n      box-shadow: ", "px\n          ", "px 0 0,\n        ", "px\n          ", "px 0 0,\n        ", "px ", "px\n          0 0,\n        ", "px ", "px\n          0 0,\n        0 ", "px 0 0,\n        ", "px 0 0 0,\n        ", "px 0 0 0,\n        0 ", "px 0 0;\n    }\n    75% {\n      box-shadow: ", "px\n          ", "px 0 0,\n        ", "px\n          ", "px 0 0,\n        ", "px ", "px\n          0 0,\n        ", "px ", "px\n          0 0,\n        0 ", "px 0 0,\n        ", "px 0 0 0,\n        ", "px 0 0 0,\n        0 ", "px 0 0;\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"]);
    return rn = function rn() {
      return n;
    }, n;
  }

  nn.propTypes = $;

  var en = r.div(rn(), function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.pixelSize;
  }, function (n) {
    return n.pixelSize;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.color;
  }, function (n) {
    return 1.5 * n.pixelSize;
  }, function (n) {
    return 1.5 * n.pixelSize;
  }, function (n) {
    return -1.5 * n.pixelSize;
  }, function (n) {
    return -1.5 * n.pixelSize;
  }, function (n) {
    return 1.5 * n.pixelSize;
  }, function (n) {
    return -1.5 * n.pixelSize;
  }, function (n) {
    return -1.5 * n.pixelSize;
  }, function (n) {
    return 1.5 * n.pixelSize;
  }, function (n) {
    return 1.5 * n.pixelSize;
  }, function (n) {
    return 1.5 * n.pixelSize;
  }, function (n) {
    return -1.5 * n.pixelSize;
  }, function (n) {
    return -1.5 * n.pixelSize;
  }, function (n) {
    return n.animationDuration;
  }, function (n) {
    return 2 * n.pixelSize;
  }, function (n) {
    return 2 * n.pixelSize;
  }, function (n) {
    return -2 * n.pixelSize;
  }, function (n) {
    return -2 * n.pixelSize;
  }, function (n) {
    return 2 * n.pixelSize;
  }, function (n) {
    return -2 * n.pixelSize;
  }, function (n) {
    return -2 * n.pixelSize;
  }, function (n) {
    return 2 * n.pixelSize;
  }, function (n) {
    return n.pixelSize;
  }, function (n) {
    return n.pixelSize;
  }, function (n) {
    return -1 * n.pixelSize;
  }, function (n) {
    return -1 * n.pixelSize;
  }, function (n) {
    return 2 * n.pixelSize;
  }, function (n) {
    return 2 * n.pixelSize;
  }, function (n) {
    return -2 * n.pixelSize;
  }, function (n) {
    return -2 * n.pixelSize;
  }, function (n) {
    return 2 * n.pixelSize;
  }, function (n) {
    return -2 * n.pixelSize;
  }, function (n) {
    return -2 * n.pixelSize;
  }, function (n) {
    return 2 * n.pixelSize;
  }, function (n) {
    return n.pixelSize;
  }, function (n) {
    return n.pixelSize;
  }, function (n) {
    return -1 * n.pixelSize;
  }, function (n) {
    return -1 * n.pixelSize;
  }),
      tn = {
    size: i.number,
    animationDuration: i.number,
    color: i.string,
    className: i.string,
    style: i.object
  },
      on = function on(n) {
    var i = n.size,
        r = void 0 === i ? 70 : i,
        e = n.color,
        t = void 0 === e ? "#fff" : e,
        o = n.animationDuration,
        a = void 0 === o ? 1500 : o,
        c = n.className,
        s = void 0 === c ? "" : c,
        u = n.style,
        l = h(n, ["size", "color", "animationDuration", "className", "style"]),
        m = r / 7;
    return p.createElement(en, d({
      size: r,
      color: t,
      animationDuration: a,
      className: "pixel-spinner" + (s ? " " + s : ""),
      style: u,
      pixelSize: m
    }, l), p.createElement("div", {
      className: "pixel-spinner-inner"
    }));
  };

  function an() {
    var n = e(["\n  height: ", "px;\n  width: ", "px;\n  position: relative;\n\n  * {\n    box-sizing: border-box;\n  }\n\n  .circle {\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    top: 0;\n    left: 0;\n    animation: radar-spinner-animation ", "ms\n      infinite;\n  }\n  .circle:nth-child(1) {\n    padding: ", "px;\n    animation-delay: ", "ms;\n  }\n  .circle:nth-child(2) {\n    padding: ", "px;\n    animation-delay: ", "ms;\n  }\n  .circle:nth-child(3) {\n    padding: ", "px;\n    animation-delay: ", "ms;\n  }\n  .circle:nth-child(4) {\n    padding: ", "px;\n    animation-delay: 0ms;\n  }\n  .circle-inner,\n  .circle-inner-container {\n    height: 100%;\n    width: 100%;\n    border-radius: 50%;\n    border: ", "px solid transparent;\n  }\n  .circle-inner {\n    border-left-color: ", ";\n    border-right-color: ", ";\n  }\n  @keyframes radar-spinner-animation {\n    50% {\n      transform: rotate(180deg);\n    }\n    100% {\n      transform: rotate(0deg);\n    }\n  }\n"]);
    return an = function an() {
      return n;
    }, n;
  }

  on.propTypes = tn;
  var cn = r.div(an(), function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.animationDuration;
  }, function (n) {
    return 2 * n.borderWidth * 0;
  }, function (n) {
    return .15 * n.animationDuration;
  }, function (n) {
    return 2 * n.borderWidth * 1;
  }, function (n) {
    return .15 * n.animationDuration;
  }, function (n) {
    return 2 * n.borderWidth * 2;
  }, function (n) {
    return .15 * n.animationDuration;
  }, function (n) {
    return 2 * n.borderWidth * 3;
  }, function (n) {
    return n.borderWidth;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.color;
  }),
      sn = {
    size: i.number,
    animationDuration: i.number,
    color: i.string,
    className: i.string,
    style: i.object
  };

  var un = function un(n) {
    var i,
        r = n.size,
        e = void 0 === r ? 110 : r,
        t = n.color,
        o = void 0 === t ? "#fff" : t,
        a = n.animationDuration,
        c = void 0 === a ? 2e3 : a,
        s = n.className,
        u = void 0 === s ? "" : s,
        l = n.style,
        m = h(n, ["size", "color", "animationDuration", "className", "style"]),
        f = 5 * e / 110;
    return p.createElement(cn, d({
      size: e,
      color: o,
      animationDuration: c,
      className: "radar-spinner" + (u ? " " + u : ""),
      style: l,
      borderWidth: f
    }, m), (i = 4, Array.from({
      length: i
    }).map(function (n, i) {
      return p.createElement("div", {
        key: i,
        className: "circle"
      }, p.createElement("div", {
        className: "circle-inner-container"
      }, p.createElement("div", {
        className: "circle-inner"
      })));
    })));
  };

  function ln() {
    var n = e(["\n  height: ", "px;\n  width: ", "px;\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  animation: scaling-squares-animation ", "ms;\n  animation-iteration-count: infinite;\n  transform: rotate(0deg);\n\n  * {\n    box-sizing: border-box;\n  }\n\n  .square {\n    height: calc(", "px * 0.25 / 1.3);\n    width: calc(", "px * 0.25 / 1.3);\n    margin-right: auto;\n    margin-left: auto;\n    border: calc(", "px * 0.04 / 1.3) solid\n      ", ";\n    position: absolute;\n    animation-duration: ", "ms;\n    animation-iteration-count: infinite;\n  }\n  .square:nth-child(1) {\n    animation-name: scaling-squares-spinner-animation-child-1;\n  }\n  .square:nth-child(2) {\n    animation-name: scaling-squares-spinner-animation-child-2;\n  }\n  .square:nth-child(3) {\n    animation-name: scaling-squares-spinner-animation-child-3;\n  }\n  .square:nth-child(4) {\n    animation-name: scaling-squares-spinner-animation-child-4;\n  }\n  @keyframes scaling-squares-animation {\n    50% {\n      transform: rotate(90deg);\n    }\n    100% {\n      transform: rotate(180deg);\n    }\n  }\n  @keyframes scaling-squares-spinner-animation-child-1 {\n    50% {\n      transform: translate(150%, 150%) scale(2, 2);\n    }\n  }\n  @keyframes scaling-squares-spinner-animation-child-2 {\n    50% {\n      transform: translate(-150%, 150%) scale(2, 2);\n    }\n  }\n  @keyframes scaling-squares-spinner-animation-child-3 {\n    50% {\n      transform: translate(-150%, -150%) scale(2, 2);\n    }\n  }\n  @keyframes scaling-squares-spinner-animation-child-4 {\n    50% {\n      transform: translate(150%, -150%) scale(2, 2);\n    }\n  }\n"]);
    return ln = function ln() {
      return n;
    }, n;
  }

  un.propTypes = sn;
  var mn = r.div(ln(), function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.animationDuration;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.animationDuration;
  }),
      fn = {
    size: i.number,
    animationDuration: i.number,
    color: i.string,
    className: i.string,
    style: i.object
  };

  var pn = function pn(n) {
    var i,
        r = n.size,
        e = void 0 === r ? 65 : r,
        t = n.color,
        o = void 0 === t ? "#fff" : t,
        a = n.animationDuration,
        c = void 0 === a ? 1250 : a,
        s = n.className,
        u = void 0 === s ? "" : s,
        l = n.style,
        m = h(n, ["size", "color", "animationDuration", "className", "style"]);
    return p.createElement(mn, d({
      size: e,
      color: o,
      animationDuration: c,
      className: "scaling-squares-spinner" + (u ? " " + u : ""),
      style: l
    }, m), (i = 4, Array.from({
      length: i
    }).map(function (n, i) {
      return p.createElement("div", {
        key: i,
        className: "square"
      });
    })));
  };

  function dn() {
    var n = e(["\n  height: ", "px;\n  width: ", "px;\n  top: ", "px;\n\n  * {\n    box-sizing: border-box;\n  }\n\n  .square {\n    height: ", "px;\n    width: ", "px;\n    top: ", "px;\n    margin-right: calc(", "px / 3);\n    margin-top: calc(", "px / 3);\n    background: ", ";\n    float: left;\n    position: relative;\n    opacity: 0;\n    animation: self-building-square-spinner\n      ", "ms infinite;\n  }\n  .square:nth-child(1) {\n    animation-delay: calc(", "ms * 6);\n  }\n  .square:nth-child(2) {\n    animation-delay: calc(", "ms * 7);\n  }\n  .square:nth-child(3) {\n    animation-delay: calc(", "ms * 8);\n  }\n  .square:nth-child(4) {\n    animation-delay: calc(", "ms * 3);\n  }\n  .square:nth-child(5) {\n    animation-delay: calc(", "ms * 4);\n  }\n  .square:nth-child(6) {\n    animation-delay: calc(", "ms * 5);\n  }\n  .square:nth-child(7) {\n    animation-delay: calc(", "ms * 0);\n  }\n  .square:nth-child(8) {\n    animation-delay: calc(", "ms * 1);\n  }\n  .square:nth-child(9) {\n    animation-delay: calc(", "ms * 2);\n  }\n  .clear {\n    clear: both;\n  }\n  @keyframes self-building-square-spinner {\n    0% {\n      opacity: 0;\n    }\n    5% {\n      opacity: 1;\n      top: 0;\n    }\n    50.9% {\n      opacity: 1;\n      top: 0;\n    }\n    55.9% {\n      opacity: 0;\n      top: inherit;\n    }\n  }\n"]);
    return dn = function dn() {
      return n;
    }, n;
  }

  pn.propTypes = fn;
  var hn = r.div(dn(), function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return -1 * n.initialTopPosition;
  }, function (n) {
    return n.size / 4;
  }, function (n) {
    return n.size / 4;
  }, function (n) {
    return -1 * n.initialTopPosition;
  }, function (n) {
    return n.size / 4;
  }, function (n) {
    return n.size / 4;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.animationDuration;
  }, function (n) {
    return .05 * n.animationDuration;
  }, function (n) {
    return .05 * n.animationDuration;
  }, function (n) {
    return .05 * n.animationDuration;
  }, function (n) {
    return .05 * n.animationDuration;
  }, function (n) {
    return .05 * n.animationDuration;
  }, function (n) {
    return .05 * n.animationDuration;
  }, function (n) {
    return .05 * n.animationDuration;
  }, function (n) {
    return .05 * n.animationDuration;
  }, function (n) {
    return .05 * n.animationDuration;
  }),
      xn = {
    size: i.number,
    animationDuration: i.number,
    color: i.string,
    className: i.string,
    style: i.object
  };

  var gn = function gn(n) {
    var i,
        r = n.size,
        e = void 0 === r ? 40 : r,
        t = n.color,
        o = void 0 === t ? "#fff" : t,
        a = n.animationDuration,
        c = void 0 === a ? 6e3 : a,
        s = n.className,
        u = void 0 === s ? "" : s,
        l = n.style,
        m = h(n, ["size", "color", "animationDuration", "className", "style"]),
        f = e / 6;
    return p.createElement(hn, d({
      size: e,
      color: o,
      animationDuration: c,
      className: "self-building-square-spinner" + (u ? " " + u : ""),
      style: l,
      initialTopPosition: f
    }, m), (i = 9, Array.from({
      length: i
    }).map(function (n, i) {
      return p.createElement("div", {
        key: i,
        className: "square" + (i % 3 == 0 ? " clear" : "")
      });
    })));
  };

  function bn() {
    var n = e(["\n  height: ", "px;\n  width: ", "px;\n  position: relative;\n\n  * {\n    box-sizing: border-box;\n  }\n\n  .ring {\n    border-radius: 50%;\n    position: absolute;\n    border: calc(", "px * 0.05) solid transparent;\n    border-top-color: ", ";\n    border-left-color: ", ";\n    animation: semipolar-spinner-animation\n      ", "ms infinite;\n  }\n  .ring:nth-child(1) {\n    height: calc(\n      ", "px - ", "px * 0.2 * 0\n    );\n    width: calc(\n      ", "px - ", "px * 0.2 * 0\n    );\n    top: calc(", "px * 0.1 * 0);\n    left: calc(", "px * 0.1 * 0);\n    animation-delay: calc(", "ms * 0.1 * 4);\n    z-index: 5;\n  }\n  .ring:nth-child(2) {\n    height: calc(\n      ", "px - ", "px * 0.2 * 1\n    );\n    width: calc(\n      ", "px - ", "px * 0.2 * 1\n    );\n    top: calc(", "px * 0.1 * 1);\n    left: calc(", "px * 0.1 * 1);\n    animation-delay: calc(", "ms * 0.1 * 3);\n    z-index: 4;\n  }\n  .ring:nth-child(3) {\n    height: calc(\n      ", "px - ", "px * 0.2 * 2\n    );\n    width: calc(\n      ", "px - ", "px * 0.2 * 2\n    );\n    top: calc(", "px * 0.1 * 2);\n    left: calc(", "px * 0.1 * 2);\n    animation-delay: calc(", "ms * 0.1 * 2);\n    z-index: 3;\n  }\n  .ring:nth-child(4) {\n    height: calc(\n      ", "px - ", "px * 0.2 * 3\n    );\n    width: calc(\n      ", "px - ", "px * 0.2 * 3\n    );\n    top: calc(", "px * 0.1 * 3);\n    left: calc(", "px * 0.1 * 3);\n    animation-delay: calc(", "ms * 0.1 * 1);\n    z-index: 2;\n  }\n  .ring:nth-child(5) {\n    height: calc(\n      ", "px - ", "px * 0.2 * 4\n    );\n    width: calc(\n      ", "px - ", "px * 0.2 * 4\n    );\n    top: calc(", "px * 0.1 * 4);\n    left: calc(", "px * 0.1 * 4);\n    animation-delay: calc(", "ms * 0.1 * 0);\n    z-index: 1;\n  }\n  @keyframes semipolar-spinner-animation {\n    50% {\n      transform: rotate(360deg) scale(0.7);\n    }\n  }\n"]);
    return bn = function bn() {
      return n;
    }, n;
  }

  gn.propTypes = xn;
  var zn = r.div(bn(), function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.animationDuration;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.animationDuration;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.animationDuration;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.animationDuration;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.animationDuration;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.animationDuration;
  }),
      yn = {
    size: i.number,
    animationDuration: i.number,
    color: i.string,
    className: i.string,
    style: i.object
  };

  var vn = function vn(n) {
    var i,
        r = n.size,
        e = void 0 === r ? 65 : r,
        t = n.color,
        o = void 0 === t ? "#fff" : t,
        a = n.animationDuration,
        c = void 0 === a ? 2e3 : a,
        s = n.className,
        u = void 0 === s ? "" : s,
        l = n.style,
        m = h(n, ["size", "color", "animationDuration", "className", "style"]);
    return p.createElement(zn, d({
      size: e,
      color: o,
      animationDuration: c,
      className: "semipolar-spinner" + (u ? " " + u : ""),
      style: l
    }, m), (i = 5, Array.from({
      length: i
    }).map(function (n, i) {
      return p.createElement("div", {
        key: i,
        className: "ring"
      });
    })));
  };

  function Dn() {
    var n = e(["\n  height: ", "px;\n  width: ", "px;\n\n  * {\n    box-sizing: border-box;\n  }\n\n  .spring-spinner-part {\n    overflow: hidden;\n    height: calc(", "px / 2);\n    width: ", "px;\n  }\n  .spring-spinner-part.bottom {\n    transform: rotate(180deg) scale(-1, 1);\n  }\n  .spring-spinner-rotator {\n    width: ", "px;\n    height: ", "px;\n    border: calc(", "px / 7) solid transparent;\n    border-right-color: ", ";\n    border-top-color: ", ";\n    border-radius: 50%;\n    box-sizing: border-box;\n    animation: spring-spinner-animation ", "ms\n      ease-in-out infinite;\n    transform: rotate(-200deg);\n  }\n  @keyframes spring-spinner-animation {\n    0% {\n      border-width: calc(", "px / 7);\n    }\n    25% {\n      border-width: calc(", "px / 23.33);\n    }\n    50% {\n      transform: rotate(115deg);\n      border-width: calc(", "px / 7);\n    }\n    75% {\n      border-width: calc(", "px / 23.33);\n    }\n    100% {\n      border-width: calc(", "px / 7);\n    }\n  }\n"]);
    return Dn = function Dn() {
      return n;
    }, n;
  }

  vn.propTypes = yn;

  var Nn = r.div(Dn(), function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.animationDuration;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }),
      wn = {
    size: i.number,
    animationDuration: i.number,
    color: i.string,
    className: i.string,
    style: i.object
  },
      Sn = function Sn(n) {
    var i = n.size,
        r = void 0 === i ? 70 : i,
        e = n.color,
        t = void 0 === e ? "#fff" : e,
        o = n.animationDuration,
        a = void 0 === o ? 3e3 : o,
        c = n.className,
        s = void 0 === c ? "" : c,
        u = n.style,
        l = h(n, ["size", "color", "animationDuration", "className", "style"]);
    return p.createElement(Nn, d({
      size: r,
      color: t,
      animationDuration: a,
      className: "spring-spinner" + (s ? " " + s : ""),
      style: u
    }, l), p.createElement("div", {
      className: "spring-spinner-part top"
    }, p.createElement("div", {
      className: "spring-spinner-rotator"
    })), p.createElement("div", {
      className: "spring-spinner-part bottom"
    }, p.createElement("div", {
      className: "spring-spinner-rotator"
    })));
  };

  function kn() {
    var n = e(["\n  height: ", "px;\n  width: ", "px;\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n\n  * {\n    box-sizing: border-box;\n  }\n\n  .square {\n    height: calc(", "px * 0.25 / 1.3);\n    width: calc(", "px * 0.25 / 1.3);\n    animation-duration: ", "ms;\n    border: calc(", "px * 0.04 / 1.3) solid\n      ", ";\n    margin-right: auto;\n    margin-left: auto;\n    position: absolute;\n    animation-iteration-count: infinite;\n  }\n  .square:nth-child(1) {\n    animation-name: swapping-squares-animation-child-1;\n    animation-delay: ", "ms;\n  }\n  .square:nth-child(2) {\n    animation-name: swapping-squares-animation-child-2;\n    animation-delay: 0ms;\n  }\n  .square:nth-child(3) {\n    animation-name: swapping-squares-animation-child-3;\n    animation-delay: ", "ms;\n  }\n  .square:nth-child(4) {\n    animation-name: swapping-squares-animation-child-4;\n    animation-delay: 0ms;\n  }\n  @keyframes swapping-squares-animation-child-1 {\n    50% {\n      transform: translate(150%, 150%) scale(2, 2);\n    }\n  }\n  @keyframes swapping-squares-animation-child-2 {\n    50% {\n      transform: translate(-150%, 150%) scale(2, 2);\n    }\n  }\n  @keyframes swapping-squares-animation-child-3 {\n    50% {\n      transform: translate(-150%, -150%) scale(2, 2);\n    }\n  }\n  @keyframes swapping-squares-animation-child-4 {\n    50% {\n      transform: translate(150%, -150%) scale(2, 2);\n    }\n  }\n"]);
    return kn = function kn() {
      return n;
    }, n;
  }

  Sn.propTypes = wn;
  var En = r.div(kn(), function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.animationDuration;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.color;
  }, function (n) {
    return .5 * n.animationDuration;
  }, function (n) {
    return .5 * n.animationDuration;
  }),
      qn = {
    size: i.number,
    animationDuration: i.number,
    color: i.string,
    className: i.string,
    style: i.object
  };

  var Bn = function Bn(n) {
    var i,
        r = n.size,
        e = void 0 === r ? 65 : r,
        t = n.color,
        o = void 0 === t ? "#fff" : t,
        a = n.animationDuration,
        c = void 0 === a ? 1e3 : a,
        s = n.className,
        u = void 0 === s ? "" : s,
        l = n.style,
        m = h(n, ["size", "color", "animationDuration", "className", "style"]);
    return p.createElement(En, d({
      size: e,
      color: o,
      animationDuration: c,
      className: "swapping-squares-spinner" + (u ? " " + u : ""),
      style: l
    }, m), (i = 4, Array.from({
      length: i
    }).map(function (n, i) {
      return p.createElement("div", {
        key: i,
        className: "square"
      });
    })));
  };

  function jn() {
    var n = e(["\n  height: ", "px;\n  width: ", "px;\n  padding: 3px;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: row;\n  overflow: hidden;\n  box-sizing: border-box;\n\n  * {\n    box-sizing: border-box;\n  }\n\n  .circle {\n    position: absolute;\n    display: block;\n    border-radius: 50%;\n    border: 3px solid ", ";\n    opacity: 1;\n  }\n  .circle:nth-child(1) {\n    height: ", "px;\n    width: ", "px;\n    animation: trinity-rings-spinner-circle1-animation\n      ", "ms infinite linear;\n    border-width: 3px;\n  }\n  .circle:nth-child(2) {\n    height: calc(", "px * 0.65);\n    width: calc(", "px * 0.65);\n    animation: trinity-rings-spinner-circle2-animation\n      ", "ms infinite linear;\n    border-width: 2px;\n  }\n  .circle:nth-child(3) {\n    height: calc(", "px * 0.1);\n    width: calc(", "px * 0.1);\n    animation: trinity-rings-spinner-circle3-animation\n      ", "ms infinite linear;\n    border-width: 1px;\n  }\n  @keyframes trinity-rings-spinner-circle1-animation {\n    0% {\n      transform: rotateZ(20deg) rotateY(0deg);\n    }\n    100% {\n      transform: rotateZ(100deg) rotateY(360deg);\n    }\n  }\n  @keyframes trinity-rings-spinner-circle2-animation {\n    0% {\n      transform: rotateZ(100deg) rotateX(0deg);\n    }\n    100% {\n      transform: rotateZ(0deg) rotateX(360deg);\n    }\n  }\n  @keyframes trinity-rings-spinner-circle3-animation {\n    0% {\n      transform: rotateZ(100deg) rotateX(-360deg);\n    }\n    100% {\n      transform: rotateZ(-360deg) rotateX(360deg);\n    }\n  }\n"]);
    return jn = function jn() {
      return n;
    }, n;
  }

  Bn.propTypes = qn;

  var Tn = r.div(jn(), function (n) {
    return n.size;
  }, function (n) {
    return n.size;
  }, function (n) {
    return n.color;
  }, function (n) {
    return n.outerWidth;
  }, function (n) {
    return n.outerWidth;
  }, function (n) {
    return n.animationDuration;
  }, function (n) {
    return n.outerWidth;
  }, function (n) {
    return n.outerWidth;
  }, function (n) {
    return n.animationDuration;
  }, function (n) {
    return n.outerWidth;
  }, function (n) {
    return n.outerWidth;
  }, function (n) {
    return n.animationDuration;
  }),
      Zn = {
    size: i.number,
    animationDuration: i.number,
    color: i.string,
    className: i.string,
    style: i.object
  },
      Xn = function Xn(n) {
    var i = n.size,
        r = void 0 === i ? 66 : i,
        e = n.color,
        t = void 0 === e ? "#fff" : e,
        o = n.animationDuration,
        a = void 0 === o ? 1500 : o,
        c = n.className,
        s = void 0 === c ? "" : c,
        u = n.style,
        l = h(n, ["size", "color", "animationDuration", "className", "style"]),
        m = r - 6;
    return p.createElement(Tn, d({
      size: r,
      color: t,
      animationDuration: a,
      className: "trinity-rings-spinner" + (s ? " " + s : ""),
      style: u,
      outerWidth: m
    }, l), p.createElement("div", {
      className: "circle circle1"
    }), p.createElement("div", {
      className: "circle circle2"
    }), p.createElement("div", {
      className: "circle circle3"
    }));
  };

  Xn.propTypes = Zn, n.AtomSpinner = a, n.BreedingRhombusSpinner = u, n.CirclesToRhombusesSpinner = b, n.FingerprintSpinner = D, n.FlowerSpinner = k, n.FulfillingBouncingCircleSpinner = j, n.FulfillingSquareSpinner = M, n.HalfCircleSpinner = O, n.HollowDotsSpinner = F, n.IntersectingCirclesSpinner = I, n.LoopingRhombusesSpinner = Q, n.OrbitSpinner = nn, n.PixelSpinner = on, n.RadarSpinner = un, n.ScalingSquaresSpinner = pn, n.SelfBuildingSquareSpinner = gn, n.SemipolarSpinner = vn, n.SpringSpinner = Sn, n.SwappingSquaresSpinner = Bn, n.TrinityRingsSpinner = Xn, Object.defineProperty(n, "__esModule", {
    value: !0
  });
});